// src/pages/LoginPage.js
import React from "react";
import Seo from "../components/Generic/Seo"; // use your Seo component
import LoginForm from "../components/Registration/LoginForm";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";

const LoginPage = () => {
  const seoData = {
    title: "WiSE Login — Access Your Account | Women in Semiconductor Ecosystem",
    description: "Login to your WiSE account to access mentorship, event resources, community forums and member-only features within the Women in Semiconductor Ecosystem.",
    keywords: "WiSE login, women in semiconductor login, member login WiSE, access WiSE account, login women in tech community, semiconductor member login",
    pathSlug: "login",
  };

  return (
    <>
      <Seo data={seoData} />

       <GoogleAnalytics
        page={seoData.pathSlug}
        title={ seoData.title}
      />

      <div
        className="auth-page"
        style={{
          backgroundImage: `url("../assets/images/loginsignbg.png")`,
        }}
      >
        <LoginForm />
      </div>
    </>
  );
};

export default LoginPage;
